import { SiteStatusEnum } from "./Home";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { sitesStatus } from "./hooks/useGetSitesStatus";

type Props = {
  siteStatusData: sitesStatus;
};

export const SiteStatus = ({ siteStatusData }: Props) => {
  const getStatusIcon = (siteStatus: SiteStatusEnum) => {
    switch (siteStatus) {
      case SiteStatusEnum.Offline:
        return (
          <FontAwesomeIcon
            icon={faMinusCircle}
            style={{ marginRight: "10px", color: "#CC2553" }}
          />
        );
      case SiteStatusEnum.Online:
        return (
          <FontAwesomeIcon
            icon={faCheckCircle}
            style={{ marginRight: "10px", color: "#2AAC76" }}
          />
        );
      case SiteStatusEnum.Unknown:
        return (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ marginRight: "10px", color: "#E2AC37" }}
          />
        );
      default:
        return (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ marginRight: "10px", color: "#E2AC37" }}
          />
        );
    }
  };

  const getLastSeen = (date: Date | string) => {
    return moment.utc(date).to(moment(), true);
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        {siteStatusData.lastSeenTimestamp && (
          <p className="text-base">
            Last Seen: {getLastSeen(siteStatusData.lastSeenTimestamp)}
          </p>
        )}
        <p style={{ fontSize: "16px" }}>
          <b>Name: {siteStatusData.name}</b>
        </p>
        <p>
          <b>Site Name: {siteStatusData.siteName ?? "--"}</b>
        </p>

        {siteStatusData.errors &&
          siteStatusData.errors.map((error) => (
            <p className="text-base text-red-600">
              <b>Error Message:</b> {error.message}
            </p>
          ))}
      </div>
      <div style={{ fontSize: "1.5rem" }}>
        {getStatusIcon(siteStatusData.status as SiteStatusEnum)}
      </div>
    </div>
  );
};
